/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_CurrentInputs */

const en_pwf_current = /** @type {(inputs: Pwf_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current workflow`)
};

const de_pwf_current = /** @type {(inputs: Pwf_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Workflow`)
};

/**
* | output |
* | --- |
* | "Current workflow" |
*
* @param {Pwf_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_current = /** @type {((inputs?: Pwf_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_current(inputs)
	return en_pwf_current(inputs)
});